import { ApiReferenceReact } from "@scalar/api-reference-react";

// Side effects
import "@scalar/api-reference-react/style.css";

export default function Page() {
  return (
    <ApiReferenceReact
      configuration={{
        url: "/api/openapi",
        defaultHttpClient: {
          targetKey: "node",
          clientKey: "fetch"
        },
        authentication: {
          preferredSecurityScheme: "BearerAuth"
        },
        persistAuth: true
      }}
    />
  );
}
